const $classes = {
	product_card: "product-card--add-to-cart",
};

const $filtersInlineClasses = {
    wrapper: "collection-grid-inline__filters-wrapper",
    item: "filter-item",
    item_active: "filter-item-active",
    target: "product-filter",
    target_wrapper: "product-filter-wrapper"
};

const $reviewsClasses = {
    reviews_wrapper: "product-review-wrapper",
    reviews_content: "product-review-content",
    review_item_in_response: "jdgm-rev",
    pager_in_response: "jdgm-paginate",
    pager: "product-review-pagination",
    pager_item: "pagination__item",
    pager_count: "product-review-header--count",
    sort_trigger: "jdgm-sort-dropdown",
};

const $selectors = {
	$product_card: {
		quantity: `${$classes.product_card} select`,
        cake_message: `${$classes.product_card} .cookie-cake-message`,
		addToCart: `${$classes.product_card} .btn-add-to-cart`,
	},
    $reviews_wrapper: {
        shop_domain: "bangcookies.myshopify.com",
        reviews_content: `.${$reviewsClasses.reviews_wrapper} .${$reviewsClasses.reviews_content}`,
        pager: `.${$reviewsClasses.reviews_wrapper} .${$reviewsClasses.pager}`,
        pager_item: `.${$reviewsClasses.reviews_wrapper} .${$reviewsClasses.pager_item}`,
        pager_count: `.${$reviewsClasses.reviews_wrapper} .${$reviewsClasses.pager_count}`,
        sort_trigger: `.${$reviewsClasses.reviews_wrapper} .${$reviewsClasses.sort_trigger}`,
    },
  	$filters_inline: {
        wrapper: `.${$filtersInlineClasses.wrapper}`,
        item: `.${$filtersInlineClasses.wrapper} .${$filtersInlineClasses.item}`,
        item_active: `.${$filtersInlineClasses.wrapper} .${$filtersInlineClasses.item_active}`,
	}
};



/*------- simple tabs -------*/
function openTab(trigger, event) {
  var tabcontent_target = $(trigger.attr('href'));
  if(trigger.hasClass('active')){
    if(!trigger.hasClass('featured-gift-card--tab')){
     trigger.removeClass('active');
     tabcontent_target.hide();
     $('select-overlay').addClass('hide');
    }
  } else {
    trigger.siblings('.active').removeClass('active')
    trigger.addClass('active');
    tabcontent_target.siblings('.tab-content').hide();
    tabcontent_target.show();
    $('select-overlay').removeClass('hide');
  }
}

function selectedToppings(){
  const toppingSelects = $('#choose-organic-toppings input:checked');
  if(toppingSelects.length){
    let toppings = []
    $(toppingSelects).each((index, topping) => toppings.push($(topping).val()))
  	toppings.length && $("a[href='#choose-organic-toppings'] span").html(toppings.join(', '))
  }
  else{
    $("a[href='#choose-organic-toppings'] span").html('Choose your favorite')
  }  
}

$('body').on('click keyup', '.tab-trigger', function(e){
  e.preventDefault();
  if(e.type === "click" || (e.type === "keyup" && e.key === 'Enter')){
    $('.tab-trigger').each((index, tab) => {
      if(this !== tab){
        const tab_content = $(tab).attr('href');
        $(tab).removeClass('active') && $(tab_content).hide()
        selectedToppings();
      } 
    })
    openTab($(this),e);
  }
});

$('select-overlay').on('click', function(){
  $('.tab-trigger').each((index, tab) => {
    const tab_content = $(tab).attr('href');
    $(tab).removeClass('active') && $(tab_content).hide();
    selectedToppings();
  })
  $('select-overlay').addClass('hide');
})


function initBangSwiper(swiper_selector, thumbs_of_swiper = null){
  /*
    swiper_selector -> to prevent conflicts it is better to use id
    the swipe settings could be assigned in html with data attributes to the swiper_selector
    if something is not set - it gets a default val
    feel free to bring more stuff :)
    
    thumbs_of_swiper -> when slider has thumbs: the function is called like initBangSwiper('thumbs-slider', 'main-slider')
      after the thumbs-slider is initialized, it will call automaticaly init of the main-slider
  */
  var swiper_element = $(swiper_selector);
  var effect = swiper_element.data('effect') ? $(swiper_element).data('effect') : 'slide';
  
  //speed and autoplayDelay can accept value 0
  var speed = typeof swiper_element.data('speed') != "undefined" ? $(swiper_element).data('speed') : 2500;
  
  /*set data-autoplay="false" to disable autoplay; any other value in ms like 1000 2000 will activate the autoplay*/
  var autoplayDelay = typeof swiper_element.data('autoplay') != "undefined" ? $(swiper_element).data('autoplay') : 1000;
  var autoplaySubSettings = false;
  if(autoplayDelay){
    var autoplaySubSettings = {
      delay: autoplayDelay,
      disableOnInteraction: false,
    };
  }
  
  var loop = (swiper_element.data('loop') === true);
  var perViewMobile = swiper_element.data('per-view-mobile') ? $(swiper_element).data('per-view-mobile') : 1;
  var perViewTablet = swiper_element.data('per-view-tablet') ? $(swiper_element).data('per-view-tablet') : 1;
  var perViewTablet__big = swiper_element.data('per-view-tablet-big') ? $(swiper_element).data('per-view-tablet-big') : false;
  var perViewDesktop = swiper_element.data('per-view-desktop') ? $(swiper_element).data('per-view-desktop') : 1;
  var betweenMobile = swiper_element.data('between-mobile') ? $(swiper_element).data('between-mobile') : 15;
  var betweenTablet = swiper_element.data('between-tablet') ? $(swiper_element).data('between-tablet') : 15;
  var betweenDesktop = swiper_element.data('between-desktop') ? $(swiper_element).data('between-desktop') : 15;
  
  var navigationSubSettings = false;
  if($(`${swiper_selector} .bang-slide-prev`).length){
    navigationSubSettings = {
      prevEl: `${swiper_selector} .bang-slide-prev`,
      nextEl: `${swiper_selector} .bang-slide-next`,
    };
  }
  var swiper_f = new Swiper(swiper_selector, {
        effect: effect,
        slidesPerView: perViewMobile,
        spaceBetween: betweenMobile,
//         loop: loop,
        speed: 450,
        freeMode: {
          enabled: false,
          momentumRatio: 0.2,
          momentumBounce: false,
          momentumVelocityRatio: 1,
          sticky: true
        },
        noSwipingClass: 'disabled',
        noSwiping: true,
        mousewheel: false,
        direction: "horizontal",
        scrollbar: {
           //el: '.swiper-scrollbar',
           draggable: true,
        },
        pagination: {
           el: swiper_selector +" .swiper-pagination",
           clickable: true,
        },
        keyboard: {
           enabled: true,
           onlyInViewport: false,
        },
        on: {
          init: function (swiper) {
            if (swiper.slides.length <= 1) {
            }
          },
        },
        breakpoints: {
          320: {
//           	centeredSlides: true,
            spaceBetween: 0,
          },
          750: { /*750 and up to next*/
            centeredSlides: false,
            slidesPerView: perViewTablet,
            spaceBetween: betweenTablet
            
          },
          990: { /*990 and up to next*/
            slidesPerView: (perViewTablet__big ? perViewTablet__big : perViewDesktop),
            spaceBetween: betweenDesktop,
          },
          1080: {
            slidesPerView: perViewDesktop,
            spaceBetween: betweenDesktop,
          }
        },
        autoplay: autoplaySubSettings,
        thumbs: {
          swiper: thumbs_of_swiper
        },
        navigation: navigationSubSettings,
        on: {
          slideChangeTransitionStart: function(swiper){
            if(navigationSubSettings){
              if( !$(`${swiper_selector} .swiper-slide:first`).hasClass('swiper-slide-active') ){
                $(navigationSubSettings.prevEl).fadeIn();
              }
              if( !swiper.isEnd ){
                $(navigationSubSettings.nextEl).fadeIn();
              }

            }
          },
          reachBeginning: function(){
            $(navigationSubSettings.prevEl).fadeOut();
          },
          reachEnd: function(){
            $(navigationSubSettings.nextEl).fadeOut();
          }
        }
  });

  swiper_f.init();
  //swiperInitialized = true;
  if(swiper_element.data("thumbs-to")){
    initBangSwiper(swiper_element.data("thumbs-to"), swiper_f);
  }
  
  return swiper_f;
}


$('body').on('click keyup', '.btn-read-more', function(e){
  e.preventDefault();
  if(e.type === "click" || (e.type === "keyup" && e.key === 'Enter')){
    var text_wrapper = $(this).siblings('.text-read-more');
    if(text_wrapper.hasClass('text-read-more-hidden')){
      text_wrapper.removeClass('text-read-more-hidden');
      $(this).text('Hide');
    } else {
      text_wrapper.addClass('text-read-more-hidden');
      $(this).text('View more');
    }
  }
});


function toggleButtonLoading(button) {
  $(button).toggleClass("loading");
  const state = $(button).prop('disabled');
  state ? $(button).prop("disabled", false) : $(button).prop("disabled", true);
}

function addToCartProductCard(element) {
	const card = $(element).closest(`.${$classes.product_card}`);
	const id = $(element).data("variant-id");
	const quantity = $(card).find(`select`).val();
    const properties = {};
    const cake_message_input = $(card).find(`.cookie-cake-message`);    
  	const cake_message_input_parent = cake_message_input.parent();


	if (!quantity || !id) return;
    
    if(cake_message_input.length){
      if($(window).width() < 990){
        if(cake_message_input_parent.css('display') == 'none'){
          var card_info = card.parent().parent().find(`.card-information`);
          var extra_height = card_info.height();
          var multiplier = 1.7;
          var remove_extra_height = cake_message_input_parent.height();
          if($(window).width() < 750){
          	multiplier = 2;
            remove_extra_height = 0;
          }
          var position_bottom = extra_height*multiplier*-1;
          cake_message_input_parent.css('bottom',position_bottom);
          card_info.css('margin-bottom',extra_height-remove_extra_height);

          cake_message_input_parent.show();
          //return;
        }

      }
      if(!cake_message_input[0].checkValidity()) {
        inputAddValidationAlert(cake_message_input);
        return false;
      }
      /*extract prop_name from "properties[prop_name]"*/
      var property_key = cake_message_input.attr('name').match(/\[(.*?)\]/)[1];
      properties[property_key] = cake_message_input.val();
    }
  
  	const supported_deliveries = $(element).find("[id^='delivery_']");
    if (supported_deliveries.length){
      $(supported_deliveries).each((index, method) => {
        const property =  $(method).attr('name').match(/\[(.*?)\]/)[1];
        const value =  $(method).val();
        properties[property] = value;
      })
    }
    const exclude_from_free_shipping = $(element).find("#exclude_from_free_shipping");
    if(exclude_from_free_shipping.length){
      const property =  $(exclude_from_free_shipping).attr('name').match(/\[(.*?)\]/)[1];
	  properties[property] = true;
    }
  
    const foundUpsell = cart.items.length && cart.items.find(item => item.id === +id)
    if(foundUpsell && foundUpsell.properties && foundUpsell.properties._fromUpsell){
      properties['_fromUpsell'] = true;
    }


  

	const productData = {
		id,
		quantity,
        properties
	};

	toggleButtonLoading(element);

	const onSuccess = ({ items }) => {
      $(element).trigger(cartEvents.item.addToCart, items[0]);
      toggleButtonLoading(element);
      
	};

	const onFail = (res) => {
		const response = res.responseJSON;
		response && response.description ? alert(response.description) : alert("You have reached the maximum quantity for this product");
		toggleButtonLoading(element);
	};

	cartAddItem(productData, onSuccess, onFail);
}

function inputAddValidationAlert(the_input){
  the_input.focus();
  the_input.addClass('input-focus-alert shake');
  setTimeout(function(){
    the_input.removeClass('input-focus-alert shake');
  }, 5000);
}

$(document).ready(function(){
  $('.bang-swiper:not(.bang-swiper-has-thumbs), .bang-swiper-thumbs').each(function(){
    initBangSwiper('#'+$(this).attr('id'));
  });

  $(`.${$selectors.$product_card.addToCart}`).click((e) => {
    e.preventDefault();
    addToCartProductCard(e.target);
  });
  
  if($('.cg-swiper').length){
  const swiper = new Swiper('.cg-swiper', {
    slidesPerView: 4,
    centeredSlides: true,
    spaceBetween: 16,
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      750: {
        slidesPerView: 4,
        spaceBetween: 16
      },
    }
  });
  
  	swiper.slideTo(1, 100)
  }
  


});


/* Judge.me reviews
**************************************************************/
function initPDPReviews(page = 1, sort_order = null){
  if( $(`.${$reviewsClasses.reviews_wrapper}`).length < 1 ){
    return false;
  }
  const reviews_shop_domain = `${$selectors.$reviews_wrapper.shop_domain}`;
  const reviews_section = $(`.${$reviewsClasses.reviews_wrapper}`);
  const reviews_content = $(`${$selectors.$reviews_wrapper.reviews_content}`);
  const product_id = reviews_section.data('product-id');
  
  if(typeof product_id == "undefined" || !product_id){
    return false;
  }
  
  var per_page = reviews_section.data('reviews-to-show');
  if(typeof per_page == 'undefined' || !per_page){
    per_page = 20;
  }
  
  var sort_order_string = "";
  if(sort_order){
    var sort_by = "created_at",
        sort_dir = "desc";
    if(sort_order=="most-recent"){
      sort_by = "created_at";
      sort_dir = "desc";
    } else if(sort_order=="highest-rating"){
      sort_by = "rating";
      sort_dir = "desc";
    } else if(sort_order=="lowest-rating"){
      sort_by = "rating";
      sort_dir = "asc";
    } else if(sort_order=="with-pictures"){
      sort_by = "with_pictures";
      sort_dir = false;
    } else if(sort_order=="pictures-first"){
      sort_by = "pictures_first";
      sort_dir = false;
    } else if(sort_order=="videos-first"){
      sort_by = "videos_first";
      sort_dir = false;
    } else if(sort_order=="most-helpful"){
      sort_by = "most_helpful";
      sort_dir = false;
    } 
    sort_order_string = "&sort_by="+sort_by;
    if(sort_dir){
      sort_order_string += "&sort_dir="+sort_dir;
    }
  }
  
  //before call
  reviews_content.empty();
  
  var url2call = 'https://judge.me/reviews/reviews_for_widget?url='+ reviews_shop_domain +'&shop_domain='+ reviews_shop_domain +'&platform=shopify&page='+ page +'&per_page='+ per_page +'&product_id='+ product_id + sort_order_string;
  //console.log("hello", url2call);
  
  $.ajax({
    url: url2call,
    context: document.body
  }).done(function(response) {
    if(typeof response.html != "undefined" && response.html){
      var response_html = $(response.html);
      var response_html_review_items = $(`.${$reviewsClasses.review_item_in_response}`, response_html);
      //var response_pager = $(`.${$reviewsClasses.pager_in_response}`, response_html);
      
      var loop_counter = 0;
      response_html_review_items.each(function(index,val){
        var review_item = formatReviewItem($(this));
        if(review_item){
          reviews_content.append(review_item);
          loop_counter++;
        }
      });
      if(loop_counter > 0){
      }
      
      updateReviewsPager(response_html);
      updateReviewsCount(response_html, per_page, loop_counter);
    }
  });
  
}
function formatReviewItem(review_item){
  var score = parseInt(review_item.find('.jdgm-rev__rating').data('score'));
  if( score < 5 ){
    review_item.remove();
    return false;
  }
  
  var review_item_date = review_item.find('.jdgm-rev__timestamp');
  review_item_date.removeClass('jdgm-spinner');
  var d = review_item_date.data('content')
  if(typeof d != "undefined" && d){
    d = d.split(' ')[0];
    if(d){
      d = new Date(d);
      //console.log(d);
      //console.log(d.toString('dd/mm/yyyy'));
      review_item_date.text( cbFormatDate(d) );
    }
  }
  
  /*image*/
  review_item.find('.jdgm-rev__pic-link').removeClass('jdgm--loading');
  review_item.find('.jdgm-rev__pic-img').each(function(){
    $(this).attr('src', $(this).data('src'));
    $(this).attr('loading','lazy');
  });
  
  return review_item;
}

function updateReviewsCount(response_html, per_page, real_count_per_page){
  const reviews_count_wrapper = $(`${$selectors.$reviews_wrapper.pager_count}`);
  var page_current = $('.jdgm-curt', response_html).data('page');
  var page_last = $('.jdgm-paginate__last-page', response_html).data('page');
  var c_from = ((page_current-1)*per_page) + 1;
  var c_to = ((page_current-1)*per_page) + real_count_per_page;
  
  
  $(`${$selectors.$reviews_wrapper.pager_count}-from-to`).text( c_from+'-'+c_to );
  $(`${$selectors.$reviews_wrapper.pager_count}-total`).text((page_last*per_page));
}

function updateReviewsPager(response_html){
  const reviews_pager_wrapper = $(`${$selectors.$reviews_wrapper.pager}`);
  var page_current = $('.jdgm-curt', response_html).data('page');
  var page_last = $('.jdgm-paginate__last-page', response_html).data('page');
  if(!page_current || !page_last){
    return false;
  }
  var page_prelast = page_last - 1;
  
  for(var i = page_current-2, j = 0; i <= page_current+2; i++, j++){
    setReviewsPageNum($(`${$selectors.$reviews_wrapper.pager_item}.pagination__item--num`).eq(j) , i);
    if(i < 1 || i > page_last){
      $(`${$selectors.$reviews_wrapper.pager_item}.pagination__item--num`).eq(j).addClass('hide');
    } else {
      $(`${$selectors.$reviews_wrapper.pager_item}.pagination__item--num`).eq(j).removeClass('hide');
    }
  }
  
  setReviewsPageNum($(`${$selectors.$reviews_wrapper.pager_item}.pagination__item--prelast-page`), page_prelast);
  setReviewsPageNum($(`${$selectors.$reviews_wrapper.pager_item}.pagination__item--last-page`), page_last);
  
  showReviewsPageNum(reviews_pager_wrapper.find('.pagination__middle--after').removeClass('hide'), (page_current + 4 < page_last));
  showReviewsPageNum($(`${$selectors.$reviews_wrapper.pager_item}.pagination__item--prelast-page`).removeClass('hide'), (page_current + 3 < page_last));
  showReviewsPageNum($(`${$selectors.$reviews_wrapper.pager_item}.pagination__item--last-page`).removeClass('hide'), (page_current + 2 < page_last));
  
  showReviewsPageNum(reviews_pager_wrapper.find('.pagination__middle--before').removeClass('hide'), (page_current - 4 > 1));
  showReviewsPageNum($(`${$selectors.$reviews_wrapper.pager_item}.pagination__item--second-page`).removeClass('hide'), (page_current - 3 > 1));
  showReviewsPageNum($(`${$selectors.$reviews_wrapper.pager_item}.pagination__item--first-page`).removeClass('hide'), (page_current - 2 > 1));
  
  //reviews_pager_wrapper.html(response_pager.html());
}

function setReviewsPageNum(review_page, num){
  review_page.text(num).data('page', num).data('label', "Page "+num);
}
function showReviewsPageNum(review_page, condition){
  if(condition){
    review_page.removeClass('hide');
  } else {
    review_page.addClass('hide');
  }
}

function gotoReviewsPage(the_trigger){
  const page = the_trigger.data('page');
  initPDPReviews(page);
}

/*
$('body').on('click keyup', `${$selectors.$reviews_wrapper.pager_item}`, function(e){
  e.preventDefault();
  if(e.type === "click" || (e.type === "keyup" && e.key === 'Enter')){
    gotoReviewsPage($(this));
  }
});
*/
//end reviews

/* Collection fiters inline
**************************************************************/
$('body').on('click keyup', `${$selectors.$filters_inline.item}`, function(e){
  e.preventDefault();
  if(e.type === "click" || (e.type === "keyup" && e.key === 'Enter')){
    filterInlineSelect($(this),e);
  }
});

function filterInlineSelect(the_trigger,e){
  const filter_inline_wrapper = the_trigger.closest(`${$selectors.$filters_inline.wrapper}`);
  const products_grid = filter_inline_wrapper.closest('.shopify-section').find('.product-grid');
  
  filter_inline_wrapper.find(`.${$filtersInlineClasses.item_active}`).removeClass(`${$filtersInlineClasses.item_active}`);
  the_trigger.addClass(`${$filtersInlineClasses.item_active}`);
  var filter_value = the_trigger.data('value');
  if(!filter_value) return false;
  
  if(filter_value == "all"){
    products_grid.find(`.${$filtersInlineClasses.target}`).removeClass('hide');
  }
  else {
    var filter_value_class = `.${$filtersInlineClasses.target}-${filter_value}`;
    products_grid.find(`.${$filtersInlineClasses.target}:not(${filter_value_class})`).addClass('hide');
    products_grid.find(`.${$filtersInlineClasses.target}${filter_value_class}`).removeClass('hide');
  }
}

/* Klaviyo
**************************************************************/
function manualKlaviyoSubmission(e) {
      e.preventDefault();
      var the_form = $(e.target);
      var the_form_list_type = the_form.find("#bis_list_type").val();
      
      //var form_data = new FormData(the_form[0]);
      if(the_form_list_type == "default"){
        var form_data = {
          a: the_form.find('[name=bis_account_id]').val(),
          email: the_form.find('[name=bis_email]').val(),
          variant: the_form.find('[name=bis_variant_id]').val(),
          product: the_form.find('[name=bis_product_id]').val(),  // Product must be present in Klaviyo catalog to record event.
          platform: "shopify",
          subscribe_for_newsletter: (the_form.find('[name=accepts_marketing]').prop('checked') === true),  // Optional with "g". Defaults to false if omitted.
          g: the_form.find('[name=bis_list_id]').val(),  // Optional with "subscribe_for_newsletter".
        };
      }
      else if(the_form_list_type == "coming_soon") {
        var form_data = {
          a: the_form.find('[name=bis_account_id]').val(),
          email: the_form.find('[name=bis_email]').val(),
          platform: "shopify",
          subscribe_for_newsletter: (the_form.find('[name=accepts_marketing]').prop('checked') === true),  // Optional with "g". Defaults to false if omitted.
          g: the_form.find('[name=bis_list_id]').val(),  // Optional with "subscribe_for_newsletter".
        };
      }
      form_data['platform'] = "shopify";

      /*
  console.log(the_form_list_type);
  console.log(form_data);
  console.log(the_form.attr('action'));
      */
      //return false;

      if(typeof form_data == "undefined"){
        return false;
      }

      $.ajax({
        type: "POST",
        url: the_form.attr('action'),
        data: form_data,
        success: function(response){
          console.log(response);
          the_form.find('.alert-success').fadeIn();
          setTimeout(function(){ the_form.find('.alert-success').fadeOut(); }, 5000);
        },
        error: function(response){
          console.log(response);
          the_form.find('.alert-danger').text(response.responseJSON.message).fadeIn();
          the_form.find('.alert-danger').fadeIn();
          setTimeout(function(){ the_form.find('.alert-danger').fadeOut(); }, 5000);
        }
      });
}
$('body').on('submit', '.modal-bis-form-manual', function(e){
  manualKlaviyoSubmission(e);
});

/* Swiper - Featured collection multiple instances
**************************************************************/
var swiperFeaturedCollection = {};
var initFeaturedCollection = {};
function swiperModeFeaturedCollection(){
  let mobile = window.matchMedia('(min-width: 0px) and (max-width: 749px)');
  let tablet = window.matchMedia('(min-width: 750px) and (max-width: 989px)');
  let desktop = window.matchMedia('(min-width: 990px)');
  
  if(mobile.matches) {
    swiperModeFeaturedCollectionInitOrDestroyCheck('mobile');
  }
  else if(tablet.matches) {
    swiperModeFeaturedCollectionInitOrDestroyCheck('tablet');
  }
  else if(desktop.matches) {
    swiperModeFeaturedCollectionInitOrDestroyCheck('desktop');
  }
}
function swiperModeFeaturedCollectionInitOrDestroyCheck(media_type){
  $('.shopify-section__featured_products .collection_swiper').each(function(){
    var key = $(this).attr('id');
    if( !initFeaturedCollection[key] && ($(this).data('enable-'+media_type) === true) ){
      //console.log('y',key);
      initFeaturedCollection[key] = true;
      $(this).find('.product-grid').removeClass('grid');
      $(this).find('.swiper-slide').removeClass('grid__item');
      swiperFeaturedCollection[key] = initBangSwiper('#'+key);
    }
    else if( initFeaturedCollection[key] && !($(this).data('enable-'+media_type) === true) ){
      //console.log('des',key);
      swiperFeaturedCollection[key].destroy();
      initFeaturedCollection[key] = false;
      $(this).find('.product-grid').addClass('grid');
      $(this).find('.swiper-slide').addClass('grid__item');
    }
  });
}


/* Swiper
**************************************************************/
var swiper2 = Swiper;
var init = false;



/* Which media query
**************************************************************/
function swiperMode() {
  let mobile = window.matchMedia('(min-width: 0px) and (max-width: 749px)');
  let tablet = window.matchMedia('(min-width: 750px) and (max-width: 1024px)');
  let desktop = window.matchMedia('(min-width: 1025px)');
  if($('.product-section-inner.swiper').length > 0){
    // Enable (for mobile)
    if(mobile.matches) {
        if (!init) {
          init = true;
          if ($('.ingredients-tab__ingredient').length >= 3) {
            swiper2 = new Swiper('.product-section-inner.swiper', {
              direction: "horizontal",
              slidesPerView: 3,
              spaceBetween: 80,
              centeredSlides: true

            });
            swiper2.slideTo(1, 100)
          } else {
            swiper2 = new Swiper('.product-section-inner.swiper', {
              direction: "horizontal",
              slidesPerView: 3,
              spaceBetween: 80,
            });
          }
        }
    }

  // Disable (for tablet)
  else if(tablet.matches) {
    if(init){
        swiper2.destroy();
        init = false;
    }
  }

  // Disable (for desktop)
  else if(desktop.matches) {
    if(init){
        swiper2.destroy();
        init = false;      
    }
  }
}
}

/* On Load
**************************************************************/
window.addEventListener('load', function() {
  swiperMode();
  swiperModeFeaturedCollection();
});

/* On Resize
**************************************************************/
window.addEventListener('resize', function() {
  swiperMode();
  swiperModeFeaturedCollection();
});


function cbFormatDate(date_item){
  // d is type Date
  var dd = date_item.getDate();
  var mm = date_item.getMonth()+1; 
  var yyyy = date_item.getFullYear();
  if(dd<10){
    dd='0'+dd;
  }
  if(mm<10){
    mm='0'+mm;
  } 
  return dd+'/'+mm+'/'+yyyy;
}

  function fixButtonOnScroll(the_button){
    if(the_button.length){
      var distance_scrolled = $(window).scrollTop();
      var the_button_offset = the_button.offset().top + the_button.outerHeight();
      var treshold_for_render = the_button_offset;
		
      if( $('.fixed_filters_menu').length < 1 && distance_scrolled > treshold_for_render){
        //to add
        var the_button_clone = the_button.clone();
        the_button_clone.addClass('fixed_filters_menu').addClass('play_animation');
        //if($(window).width() > 749){
        	var get_height = $('.desktop-navigation').outerHeight();
        	get_height = 0;
			the_button_clone.css('top',get_height)
        //}
        $('body').append(the_button_clone);
        setTimeout(function(){
          the_button_clone.removeClass('play_animation');
        }, 100);
      }
      else if( $('.fixed_filters_menu').length > 0 && distance_scrolled < treshold_for_render ){
        //to remove
        $('.fixed_filters_menu').addClass('play_animation');

        $('.fixed_filters_menu').remove();

      }
    }

  }

if($('.collection_filters_type').length){
  $(window).scroll(function(){
    fixButtonOnScroll( $('.collection_filters_type') );
  });

}

//cookies stuff
function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	var expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(";");
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length); //the cvalue of the cookie
		}
	}
	return "";
}

function checkCookie(cname) {
	var cookie = getCookie(cname);
	if (cookie != "") {
		//cookie exists
		//console.log('');
	} else {
		setCookie(cname, "some val", 30);
	}
}

function checkACookieExists(cname) {
	if (document.cookie.split(";").some((item) => item.trim().startsWith(cname + "="))) {
		return true;
	}

	return false;
}

function eraseCookie(cname) {
	setCookie(cname, "", -1);
}


$(document).ready(function() {
  $('.jdgm-histogram__row').click(function() {
    for (let item of $('.jdgm-histogram__row')) {
      $(item).find('.jdgm-histogram__bar-content').css('background-color', '#000')
    }
    if ($(this).data('rating') == 1) {
      $(this).find('.jdgm-histogram__bar-content').css('background-color', '#e5bcc5');
    }
  })

  
//   $('.zapiet .zapiet-sidebar .delivery-method .method.disabled').on("click", function (e) {
//     e.preventDefault();
//     e.StopPropagation();
//   });
  $('.mobile_header_opener').on('click', function(e){
  	$('.mobile_header_opener_summary').trigger('click');
  });
  
  $('.mobile_header_backdrop').on('click', function(e){
    $('.mobile_header_opener_summary').trigger('click');
  });
  
  $('.header_megamenu_link').on('mouseenter', function(e){
    var data_for = $(this).data('for');
    
    $('.header_megamenu_link').removeClass('active');
    $(this).addClass('active');
    
    $('.header_megamenu_link_content').removeClass('active');
    $('.header_megamenu_link_content[data-for="'+data_for+'"]').addClass('active');
  });
  
  $('.header_megamenu_links_wrapper').on('mouseleave', function(e){
    $('.header_megamenu_link_content').removeClass('active');
    $('.header_megamenu_link').removeClass('active');
  });

  
      if($('.product-card-wrapper .card_certificates').length > 0){
        $('.product-card-wrapper .card_certificates').each(function( index ) {
              var result = [...$(this).find('.card_certificate')].sort((a, b) => {
                var contentA = parseInt($(a).data('sort'));
                var contentB = parseInt($(b).data('sort'));
                return (contentA < contentB) ? -1 : (contentA > contentB) ? 1 : 0;
              });
              
             $(this).html(result);
        });
      }

})

